import { Injectable } from '@angular/core';
import * as msConfig from '../../../msconfig.json';
import { environment } from '../../environments/environment';

type AppEnv = 'prod' | 'dev';

export interface FirebaseConfig {
  projectId: string;
  appId: string;
  storageBucket: string;
  apiKey: string;
  authDomain: string;
  messagingSenderId: string;
  databaseId: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly env: AppEnv = environment.env;

  get firebase(): FirebaseConfig {
    return msConfig.api.firebase[this.env];
  }

  get icureHost(): string {
    return msConfig.api.icure[this.env];
  }

  get auditServiceUrl(): string | undefined {
    return msConfig.api.audit_service[this.env];
  }
}
